"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Trigger the focus of an focusable @eg/elements component.
 * This method will return true if an element could be focused and false otherwise.
 *
 * @param dataFocusId focus the element where the data-focus-id is set to the specified parameter
 */
exports.focusElementById = function (elementId, subElement) {
    var suffix = subElement ? "-" + subElement : '';
    var nodeList = document.querySelectorAll("[data-focus-id=\"" + elementId + suffix + "\"]");
    if (nodeList.length === 1) {
        nodeList.item(0).focus();
        return true;
    }
    else {
        console.warn("Unable to focus element with focus id '" + elementId + "'");
    }
    return false;
};
exports.isInViewport = function (elem) {
    var bounding = elem.getBoundingClientRect();
    return (bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.top + bounding.height <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.left + bounding.width <= (window.innerWidth || document.documentElement.clientWidth));
};
exports.getDistanceOfElements = function (from, to) {
    var fromBottomPosition = from.getBoundingClientRect().bottom;
    var toTopPosition = to.getBoundingClientRect().top;
    var marginTop = window.getComputedStyle(to).marginTop;
    var subtractMargin = parseInt(marginTop ? marginTop : '0', 10);
    return (toTopPosition) - (fromBottomPosition + subtractMargin);
};
//# sourceMappingURL=dom.js.map